import React from "react";
import { Box } from "@mui/material";

import image1 from "../../assets/egypt.jpg";
import image2 from "../../assets/elma.jpg";
import image3 from "../../assets/Frenchitas.jpg";
import image4 from "../../assets/Lays.jpg";
import image5 from "../../assets/Leishi.jpg";
import image6 from "../../assets/Margarita.jpg";
import image7 from "../../assets/Sabritas.jpg";
import image8 from "../../assets/SaudiArabia.jpg";
import image9 from "../../assets/Smiths.jpg";
import image10 from "../../assets/Taiwan.jpg";
import image11 from "../../assets/Tapuchips.jpg";
import image12 from "../../assets/Thailand.jpg";
import { Font, Header } from "pepsico-ds";

import LoginFooter from "./LoginFooter";
import LoginPepsiSvg from "./LoginPepsiSvg";
import "./MobileSign.css";
import useLoginFlow from "../../hooks/userLoginFlow";
import LoginCardSet from "./LoginCardSet";
const imageArray = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
];

// Common styles for the overlay container
const overlayStyles = {
  position: "absolute",

  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 2,
  display: "flex",
  flexDirection: "column",
  width: "90%",
  padding: "16px",
  alignItems: "center",
  gap: "24px",
  borderRadius: "var(--Corner-radius-corner-radius-small, 8px)",
  background: "var(--Tokens-Background-Default, #F3F7FD)",
  boxShadow:
    "var(--Elevation-X-Elevation-03, 0px) var(--Elevation-Y-Elevation-03, 2px) var(--Elevation-Blur-Elevation-03, 24px) var(--Elevation-Spread-Elevation-03, 8px) var(--Elevation-Colors-Elevation-03, rgba(0, 92, 188, 0.12))",
  height: "auto", // Set height to auto to fit both cards
  maxHeight: "70vh", // Optional: limit max height to avoid overflow
  overflow: "auto", // Allow scrolling if content exceeds height
  scrollbarWidth: "none", // Firefox: Hide scrollbar
  "&::-webkit-scrollbar": {
    display: "none", // Webkit: Hide scrollbar
  },
};

// Common styles for the card components

export default function MobileSign({ setLoading }) {
  const loginFlow = useLoginFlow(setLoading);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#EFF5FC",
        flexShrink: 0,
        justifyContent: "center",
        gap: "24px",
      }}
    >
      <Header
        style={{ justifyContent: "space-between", height: "64px" }}
        leftIcon={<LoginPepsiSvg />}
        middleIcon={
          <Font size="body" variant="bold" isDark>
            Frito-Lay Agriculture
          </Font>
        }
        className="mobile-app-header"
      />

      <main
        style={{
          flex: 1,
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: "16px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {imageArray.map((image, index) => (
          <Box
            key={index}
            sx={{
              backgroundImage: `url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: "8px",
              width: "100%",
              height: "150px",
              opacity: 0.3,
            }}
          />
        ))}
      </main>

      <Box
        sx={{
          ...overlayStyles,
          top: {
            xs: "38%", // default for <600px
            sm: "42%", // 600px and above
            md: "45%", // 900px and above
          },
        }}
      >
        <LoginCardSet {...loginFlow} />
      </Box>

      <LoginFooter />
    </Box>
  );
}
